import gql from 'graphql-tag'

export const Q_GET_COMPANIES = gql`query ($where:ListWhere) {
  companies(where:$where) {
    name,
    tenantId,
    id,
    logo,
    workCloseDays,
    settings
  }
}`

export const M_UPDATE_COMPANY = gql`mutation UpdateCompany($id: Int!, $settings: JSON, $logo: String) {
  updateCompany(id: $id, settings: $settings, logo: $logo) {
    id
    settings
    logo
  }
}`
